angular.module('impactx.filehelper').service("FileHelperService", FileHelperService);

FileHelperService.$inject = ['$errorHandler', 'TranslationService'];

function FileHelperService($errorHandler, TranslationService) {

    var checkAllowedFileWithError = function (fileName) {
        return checkFileWithError(fileName, impactX.whiteListFiles);
    };

    var checkImageFileWithError = function (fileName) {
        return checkFileWithError(fileName, impactX.imageFiles);
    };

    var checkFileWithError = function (fileName, endings) {
        var result = checkFile(fileName, endings);
        if (!result) {
            $errorHandler.showErrors([{error: TranslationService.get("error_wrong_file_extension")}]);
        }
        return result;
    };

    var checkFile = function (fileName, endings) {
        if (fileName) {
            for (var i = 0; i < endings.length; i++) {
                if (fileName.toLowerCase().lastIndexOf(endings[i]) === fileName.length - endings[i].length) {
                    return true;
                }
            }
        }

        return false;
    };

    var getFileMdiClass = function (fileName) {
        if (checkFile(fileName, impactX.docFiles)) {
            return "mdi-file-document";
        }
        if (checkFile(fileName, impactX.excelFiles)) {
            return "mdi-file-excel";
        }
        if (checkFile(fileName, impactX.pdfFiles)) {
            return "mdi-file-pdf";
        }
        if (checkFile(fileName, impactX.imageFiles)) {
            return "mdi-file-image";
        }
        if (checkFile(fileName, impactX.pptFiles)) {
            return "mdi-file-powerpoint";
        }
        if (checkFile(fileName, impactX.xmlFiles)) {
            return "mdi-file-xml";
        }
        return "mdi-file";
    };


    return {
        checkAllowedFileWithError: checkAllowedFileWithError,
        checkImageFileWithError: checkImageFileWithError,
        getFileMdiClass: getFileMdiClass
    };
}